<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";
import Swal from "sweetalert2";
import Multiselect from "@vueform/multiselect";
import {driver} from "driver.js";
import "driver.js/dist/driver.css";

import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import moment from "moment";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {

  components: {
    Layout, PageHeader, DxButton,
    // DxExport segue registrado de propósito: o <DxExport> no template está
    // comentado (FLUXO ANTIGO DE EXPORTAÇÃO) e basta descomentá-lo para voltar
    // atrás, sem precisar mexer aqui também.
    // eslint-disable-next-line vue/no-unused-components
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager, DxFilterRow, DxRemoteOperations,
    Loader, Multiselect
  },
  data() {

    return {
      title: "Notas Fiscais",
      items: [
        {
          text: "Fretes",
          href: "/"
        },
        {
          text: "Notas Fiscais",
          active: true
        }
      ],
      selectedItems: 0,
      dataList: null,
      totalList: 0,
      updating: false,
      exibEmit: true,
      exibDest: false,
      exibAmbos: false,
      dtIniFiltro: null,
      dtFimFiltro: null,
      // FLUXO NOVO DE EXPORTAÇÃO — flag própria, deliberadamente separada de
      // `updating`: aquela está no v-if que envolve a grid e a desmontaria
      // durante a exportação. Esta só desabilita os botões.
      exportando: false,
      submittedPeriodo: false,
      showModalPeriodo: false,
      showAssocRoma: false,
      idRomaneioAssoc: 0,
      dtListPesqRoma: null,
      empresaData: null,

      selectedStatus: null,
      options: [
        { value: null,  text: 'Todos' },

        //Definido pelo Evandro por conta da Globopharma
        {value: 'EFN', text: 'Entrega Finalizada'},
        {value: 'OCC', text: 'Ocorrência'},
        {value: 'TRA', text: 'Em Trânsito'},


        { value: 'AAG',  text:'Aguardando Agendamento (AAG)'},
        { value: 'EL',  text: 'Elaboração (EL)'},
        { value: 'OS',  text: 'Ordem Saída (OS)'},
        { value: 'CF',  text: 'Pedido Conferido (CF)'},
        { value: 'NEM', text: 'Nota Fiscal Emitida (NEM)'},
        { value: 'NLO', text: 'Não Encontrado (NLO)'},
        { value: 'EAG', text: 'Entrega Agendada (EAG)'},
        { value: 'ENP', text: 'Entregue no Prazo (ENP)'},
        { value: 'ECR', text: 'Entregue com Ressalva (ECR)'},
        { value: 'EAT', text: 'Entregue com Atraso (EAT)'},
        { value: 'CCT', text: 'Com CTe (CCT)'},
        //{ value: 'TRA', text: 'Transferido (TRA)'},
        { value: 'ENR', text: 'Em rota de entrega (ENR)'},

        { value: 'CAN', text: 'Cancelado (CAN)'},
        { value: 'SCT', text: 'Sem CTe'},
        { value: 'NEP', text: 'Em Trânsito (Dentro do Prazo)'}, //'Dentro do Prazo (Não Entregue)'
        { value: 'NEF', text: 'Em Trânsito (Fora do Prazo)'}, //'Fora do Prazo (Não Entregue)'
      ],

      showEnviarOrdemColeta: false,
      enviarOuProgrOrdemCol: 'A',
      idsAtualizar: null,
      selectedRowKeys: [],
      showModalCriarPedido: false,
      flagGeraPed: 'individual',
      flagGeraPedOptions: [
          'Individual',
          'Coletivo'
      ],

      showModalTransp: false,
      transpCriarRomaneio: null,
      loadingTransp: false,
      dtListPesqTransp: [],

      showModalErros: false,
      showModalErrosProdutos: false,
      dtListErrors: [],
      dtListErrorsProdutos: [],

      showMovalAssocMov: false,
      idCotAssoc: 0,
      dtListPesqCota: [],
      cotaAssociado: null,
      remetCnpj: null,
      listaIds: [],

      showModalAssociaLotes: false,
      dtListAssociaLote: [],
      dtListLotes: [],
      loteSelected: [],
      lotesCache: {},
      updatingReserva: false,

      disableButton: false
    };
  },

  created() {

  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted mov-list_nv')
    this.atualizaDataList()
  },

  methods: {
    /**
     * Ids das notas selecionadas, tirando as canceladas na SEFAZ (status CAN).
     * O cancelamento chega pelo logstash em /api/movnfelistcanc; dai em diante
     * a nota nao pode ser separada, romaneada, coletada nem virar pedido - o
     * documento nao existe mais fiscalmente. Avisa quantas foram descartadas
     * em vez de sumir com elas em silencio.
     */
    idsSelecionadosNaoCancelados() {
      const linhas = this.dataGrid.getSelectedRowsData() || []
      const validas = linhas.filter(l => l.mov_status !== 'CAN')
      const descartadas = linhas.length - validas.length
      if (descartadas > 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: `${descartadas} nota(s) cancelada(s) na SEFAZ foram ignoradas.`,
          showConfirmButton: false,
          timer: 2500
        })
      }
      return validas.map(l => l.mov_id ?? l.id)
    },

    dispararXMLTransportadora(){
      const ids = this.idsSelecionadosNaoCancelados()
      this.$refs.dataGridRefKey.instance.clearSelection()
      console.log('ids selecionados para gerar DANFE:', ids)

      if (!ids || ids.length === 0) {
        Swal.fire({
          position: 'top-end',
          icon: 'warning',
          title: 'Nenhum movimento selecionado',
          showConfirmButton: false,
          timer: 2000,
        })
        return
      }

      api.post(`${getBaseUrl()}api/disparaxmltransp`,
        { ids: ids },
      ).then((res) => {
        console.log("then axios")
        console.log(res.data)

        if(res.data.success){
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: res.data.message,
            showConfirmButton: false,
            timer: 3000,
          })
        } else {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: res.data.message,
            showConfirmButton: false,
            timer: 3000,
          })
        }


      }).catch((error) => {
        console.error('Erro ao gerar disparar email:', error)

        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Falha ao disparar e-mail para transportadora!',
          showConfirmButton: false,
          timer: 3000,
        })
      })
    },

    gerarRelatorioValidacaoSaldo(){
      console.log('gerarRelatorioValidacaoSaldo')
      api.post(`${getBaseUrl()}api/relatoriovalidacaosaldo`, {
            origem: "mov",
            listItens: this.dtListErrorsProdutos
          },
          {
            responseType: 'blob'
          }
      ).then((res) => {
        console.log('then axios relatoriovalidacaosaldo')

        const blob = new Blob([res.data], {type: 'application/pdf'})
        const url = window.URL.createObjectURL(blob)

        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'Relatorio_Validacao_Saldo_Itens_movs.pdf')
        document.body.appendChild(link)
        link.click()
        link.remove()

      }).catch((error) => {
        console.log('Erro ao gerar relatório: ', error)
      })
    },

    gerarDANFE() {
      console.log('gerarDANFE')

      const ids = this.dataGrid.getSelectedRowKeys()
      this.$refs.dataGridRefKey.instance.clearSelection()
      console.log('ids selecionados para gerar DANFE:', ids)

      if (!ids || ids.length === 0) {
        Swal.fire({
          position: 'top-end',
          icon: 'warning',
          title: 'Nenhum movimento selecionado',
          showConfirmButton: false,
          timer: 2000,
        })
        return
      }

      api.post(`${getBaseUrl()}api/movGeraDanfe`,
        { listItens: ids },
        { responseType: 'blob' }
      ).then((res) => {
        console.log('response gerarDANFE', res)
        let filename = this.title + '.zip'
        const blob = new Blob([res.data], { type: 'application/octet-stream' })
        saveAs(blob, filename)
      }).catch((error) => {
        console.error('Erro ao gerar DANFE:', error)
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Falha ao gerar DANFE',
          text: (error && error.response && error.response.data) ? String(error.response.data) : '',
          showConfirmButton: false,
          timer: 3000,
        })
      })
    },

    ajuda(){
      console.log('ajuda')
      const driverObj = driver({
        showProgress: true,
        nextBtnText: 'Próximo >',
        prevBtnText: '< Anterior',
        doneBtnText: 'Finalizar',
        steps: [
          { element: '#btnImportarXml', popover: { title: 'Importar Arquivo XML', description: 'Comece por aqui, importando o arquivo XML da sua nota fiscal (NF-e).' } },
        ]
      })
      driverObj.drive()
    },


    gerarReservaSaldos() {
      console.log('gerarReservaSaldos')

      /*
      * Antes de realizar qualquer disparo, verificar se todos os lotes foram definidos
      */
      let validado = true
      this.dtListAssociaLote.forEach(item => {
        if(!item.lote || item.lote < 1) {
          validado = false
        }
      })

      if(!validado) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Todos os itens devem estar com lotes definidos!",
          showConfirmButton: false,
          timer: 3500,
        })
      } else {
        this.updatingReserva = true

        api.post(`${getBaseUrl()}api/reservasaldoloteswmsos`, {
          itens: this.dtListAssociaLote
        }).then((res) => {
          console.log("then axios reservasaldolotes");
          console.log(res.data)
          // console.log(JSON.stringify(res.data))

          this.showModalAssociaLotes = false
          this.updatingReserva = false

          if(res.data.success) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: res.data.message,
              showConfirmButton: false,
              timer: 2500,
            }).then(() => {
              this.$router.push('/wmsossaida/list')
            })
          } else {
            Swal.fire({
              position: "center",
              icon: "error",
              title: res.data.message,
              text: "Deseja visualizar erros com mais detalhes?",
              showConfirmButton: true,
              showCancelButton: true,
              confirmButtonText: "Sim",
              cancelButtonText: "Não",
            }).then((confirmed) => {
              if(confirmed.isConfirmed){

                //console.log(`Quantidade dtListErrorsProdutos: ${this.dtListErrorsProdutos.length}`)
                //console.log(JSON.stringify(this.dtListErrorsProdutos))

                if(this.dtListErrors.length > 0) {
                  this.showModalErros = true
                }

                if (this.dtListErrorsProdutos.length > 0) {
                  this.showModalErrosProdutos = true
                }
              } else {
                this.$router.push('/wmsossaida/list')
              }
            })
          }
        })
      }
    },

    selecionouLote() {
      console.log('selecionouLote')
      console.log(JSON.stringify(this.dtListAssociaLote))
    },

    pesqLotes(evt, data) {
      console.log("pesqLotes");
      console.log("evt");
      console.log(evt);
      console.log(data)

      let query = evt;
      console.log(query.length);
      if (query.length > 1) {
        api.get(`${getBaseUrl()}api/pesqlotes`, {
          params: {
            q: query,
            produto_id: data.produto_id,
            qtd: data.qtd,
          },
        })
        .then((res) => {
          console.log("then axios pesqlotes");
          console.log(res.data);

          this.lotesCache[data.produto_id] = res.data
          console.log("lotesCache atualizado:", this.lotesCache)
        }).catch(error => {
          console.log(`Erro busca lotes:`)
          console.log(error)

          this.lotesCache[data.produto_id] = []
          console.log("lotesCache atualizado:", this.lotesCache)
        })
      } else {
        this.lotesCache[data.produto_id] = []
        console.log("lotesCache atualizado:", this.lotesCache)
      }
    },

    validaEmpresasSelecionadas(linhas) {
      const remetCnpj = [...new Set(linhas.map(item => item.remetcnpj))];
      console.log(`remetCnpj: ${JSON.stringify(remetCnpj)}`)

      if(remetCnpj.length > 1) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Apenas uma empresa por validação!",
          showConfirmButton: false,
          timer: 3500,
        })

        return false
      }


      this.remetCnpj = remetCnpj[0] ?? null

      return true
    },

    validaSaldoProduto() {
      console.log('validaSaldoProduto')

      //console.log('linhas selecionadas:')
      //console.log(JSON.stringify(this.dataGrid.getSelectedRowsData()))
      const linhas = this.dataGrid.getSelectedRowsData()

      const validacaoEmpresas = this.validaEmpresasSelecionadas(linhas)
      if (!validacaoEmpresas) {
        return
      }

      const movList = [...new Set(linhas.map(item => item.mov_id))]

      api.post(`${getBaseUrl()}api/validasaldoprod`, {
        listaIds: movList,
        remetcnpj: this.remetCnpj,
        tabela: 'mov'
      }).then((res) => {
        console.log('then axios validasaldoprod')
        console.log(res.data)
        // console.log(JSON.stringify(res.data))

        if(res.data.success && res.data.validado) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            text: res.data.message,
            showConfirmButton: false,
            timer: 2500,
          })
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            text: res.data.error,
            showConfirmButton: false,
            timer: 2500,
          }).then(() => {
            this.dtListErrorsProdutos = res.data.listaProdutos

            this.listaIds = res.data.origens_id

            if (this.dtListErrorsProdutos && this.dtListErrorsProdutos.length > 0) {
              this.showModalErrosProdutos = true
            }
          })
        }
      }).then(() => {
        this.dtListErrors = []
        this.dtListErrorsProdutos = []
      })
    },

    criaMovAjtFromMov() {
      console.log('criaMovAjtFromMov')
      this.showModalErrosProdutos = false
      this.disableButton = true

      api.post(`${getBaseUrl()}api/criamovajtmovs`, {
        produtosErros: this.dtListErrorsProdutos,
        remetcnpj: this.remetCnpj,
        tabela: 'mov',
        origens_id: this.listaIds
      }).then((res) => {
        console.log('then axios criamovajtmovs')
        console.log(JSON.stringify(res.data))

        this.disableButton = false

        if (res.data.success) {
          console.log(('opening new movajuste...'))

          Swal.fire({
            position: "top-end",
            icon: "success",
            text: res.data.message ?? "Ajuste criado com sucesso!",
            showConfirmButton: false,
            timer: 2500,
          }).then(() => {
            const movajt_id = res.data.movajt_id

            if(movajt_id > 0) {
              let route = this.$router.resolve(`/movajuste/editar/${movajt_id}`);
              window.open(route.href, '_blank');
              this.showModalErrosProdutos = false
            } else {
              let route = this.$router.resolve(`/movajustes/list`);
              window.open(route.href, '_blank');
            }
          });
        }else{
          Swal.fire({
            position: "top-end",
            icon: "error",
            text: res.data.error ?? "Criação de Ajuste Falhou!",
            showConfirmButton: false,
            timer: 3000,
          }).then(() => {
            this.carregarDados()
          });
        }
      }).then(() => {
        this.dtListErrors = []
        this.dtListErrorsProdutos = []
      })
    },

    formatCotaAssociado(){
      console.log('formatCotaAssociado')

      this.cotaAssociado = this.dtListPesqCota.find((item) => {
        return item.id === this.idCotAssoc
      })
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss";
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime;
    },

    confirmarAssocMov() {
      let idmov = this.idsSelecionadosNaoCancelados()
      console.log(idmov)

      if (idmov.length > 1) {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "Apenas 1 Nota pode ser associado a 1 Cotação",
          showConfirmButton: false,
          timer: 2500
        }).then(() => {
          this.showMovalAssocMov = false
        })
      } else {
        this.showMovalAssocMov = false
        this.updating = true
        api.get(`${getBaseUrl()}api/movassocota`,{
          params: {
            'idmov': idmov[0],
            'cotafrt_id': this.idCotAssoc
          }
        }).then(response => {
          console.log('response.data')
          console.log(response.data)

          if(response.data.success) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: response.data.message,
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.atualizaDataList()
              this.cotaAssociado = null
            })
          } else {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: response.data.error,
              showConfirmButton: false,
              timer: 3500
            }).then(() => {
              this.cotaAssociado = null
            })
          }
          this.updating = false
        })
      }
    },

    pesqCotacao(evt) {
      console.log('pesqCotacao')

      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingTransp = true

        api.get(`${getBaseUrl()}api/cotafrtpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)

          this.dtListPesqCota = res.data
        })
      }
    },

    associarMovCotacao(){
      console.log('associarMovCotacao')

      this.showMovalAssocMov = true
    },

    indicaTranspAssocRomaneio(){
      this.showModalTransp = true
      this.showAssocRoma = false
    },

    pesqTransp(evt){
      console.log('pesqTransp')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingTransp = true

        api.get(`${getBaseUrl()}api/transpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)

          this.dtListPesqTransp = res.data
        })
      }
    },


    confirmarTransp(){
      console.log('confirmarTransp')
      this.showModalTransp = false

      this.confirmarAssocRomaNovo2()
    },

    atualizarItensSelecionados(e) {
      this.selectedItems = e.selectedRowsData.length; // Atualiza selectedItems com o número de linhas selecionadas
    },

    criarPedido(){
      console.log('criarPedido')
      let listaNotas = this.idsSelecionadosNaoCancelados()

      Swal.fire({
        position: 'center',
        icon: 'info',
        text: 'Deseja criar 1 pedido para cada nota(1-1) ou 1 pedido para todas as notas(1-n)?',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Coletivo',
        cancelButtonText: 'Individual'
      }).then(selected => {
        api.get(`${getBaseUrl()}api/movgerapedido`,{
          params: {
            'ids': listaNotas,
            'multiplosPedidos': selected.isConfirmed
          }
        }).then(response => {
          console.log(response.data)
          if(!response.data.success){
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              text: response.data.message,
              showCancelButton: false,
              showConfirmButton: false,
              timer: 4000
            })
          }else{
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              text: 'Redirecionando para página de pedidos',
              showCancelButton: false,
              showConfirmButton: false,
              timer: 3000
            }).then(() => {
              if(selected.isConfirmed){
                this.$router.replace(`/pedido/detalhe/${response.data.pedido_id}`)
              }else{
                this.$router.replace(`/pedidos/list`)
              }
            })
          }
        })
      })
    },

    confirmarEnvioOrdemColeta() {
      this.showEnviarOrdemColeta = false
      api.post(`${getBaseUrl()}api/disparaxmltransp`,
        { ids: this.idsAtualizar },
      ).then((res) => {
        if (res.data.success) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: res.data.message,
            showConfirmButton: false,
            timer: 3000,
          }).then(() => {
            this.atualizaDataList()
          })
        } else {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: res.data.message,
            showConfirmButton: false,
            timer: 3000,
          })
        }
      }).catch((error) => {
        console.error('Erro ao disparar XML para transportadora:', error)
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Falha ao disparar e-mail para transportadora!',
          showConfirmButton: false,
          timer: 3000,
        })
      })
    },


    envioOrdemColeta(){
      console.log('envioOrdemColeta')
      this.idsAtualizar = this.idsSelecionadosNaoCancelados()
      console.log('idsAtualizar')
      console.log(this.idsAtualizar)
      console.log(this.idsAtualizar.length)
      if (this.idsAtualizar.length === 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Nenhum movimento foi selecionado, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        this.dataGrid.clearSelection()

        this.showEnviarOrdemColeta = true

      }
    },


    pesqRomaneio(evt){
      console.log('pesqRomaneio')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/wmsromapesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqRoma = res.data
        });
      }
    },

    associarRomaneio() {
      console.log('associarRomaneio')
      const idsAtualizar = this.idsSelecionadosNaoCancelados()
      console.log('idsAtualizar: ', idsAtualizar)

      // let algumAssoc = false
      // this.wmsosList.forEach((value) => {
      //   // console.log(value)
      //   if (value.checked === true){
      //     algumAssoc = true
      //     // idsAssoc = idsAssoc + value.id.toString()
      //   }
      // })
      if (idsAtualizar.length === 0) {

        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor selecionar algum movimento antes de associar.",
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        this.showAssocRoma = true
      }
    },

    confirmarAssocRoma(){
      console.log('associarRomaneio')
      const transpRoma = this.dataGrid.getSelectedRowsData()[0]['transpcnpj']
      console.log('transp: ' , transpRoma)
      const idsAtualizar = this.idsSelecionadosNaoCancelados()
      console.log('idsAtualizar: ' , idsAtualizar)

      api.post(`${getBaseUrl()}api/wmsromamov`, {
        idRoma: this.idRomaneioAssoc,
        idsData: idsAtualizar,
        transpmov: transpRoma
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        // this.produtoData = res.data[0]
        // this.loadingList = false
        this.showAssocRoma = false

        if(res.data[0] === 'success'){
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            const routeData = this.$router.resolve(`/wmsromaneio/editar/` + this.idRomaneioAssoc)
            window.open(routeData.href, '_blank')
          })
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data[1],
            showConfirmButton: false,
            timer: 2500
          })
        }

        this.atualizaDataList()
      })
    },

    confirmarAssocRoma2(){
      console.log('associarRomaneio2')
      const idsAtualizar = this.idsSelecionadosNaoCancelados()
      console.log('idsAtualizar: ' , idsAtualizar)

      api.post(`${getBaseUrl()}api/wmsromamov`, {
        idRoma: this.idRomaneioAssoc,
        idsData: idsAtualizar,
        origem: 'mov'
      }).then((res) => {
        console.log('then axios associarRomaneio 2')
        console.log(res.data)

        this.showAssocRoma = false

        if(res.data.success){
          if(res.data.listMovsNaoAssociadas && res.data.listMovsNaoAssociadas.length > 0){
            Swal.fire({
              position: "center",
              icon: "warning",
              title: "Algumas notas não puderam ser associadas!",
              showConfirmButton: true,
              showCancelButton: true,
              confirmButtonText: 'Baixar erros',
              cancelButtonText: 'Ir para romaneio',
            }).then(escolha => {
              if(escolha.isConfirmed){
                // Monta o conteúdo do arquivo
                let conteudo = res.data.listMovsNaoAssociadas
                    .map(item => `Nota Fiscal: ${item.numnf ?? '-'} | ID: ${item.mov_id} | Erro: ${item.error} | Id Romaneio: ${item.wmsroma_id}`)
                    .join('\n'); // Garante a quebra de linha entre mensagens

                // Cria um Blob com os dados em formato de texto
                const blob = new Blob([conteudo], { type: 'text/plain' });

                // Cria um link temporário para download
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = 'erros_notas.txt';

                // Adiciona ao DOM e clica no link para iniciar o download
                document.body.appendChild(link);
                link.click();

                // Remove o link do DOM após o download
                document.body.removeChild(link);

                const routeData = this.$router.resolve(`/wmsromaneio/editar/` + res.data.wmsromaneio_id)
                window.open(routeData.href, '_blank')
              }else{
                const routeData = this.$router.resolve(`/wmsromaneio/editar/` + res.data.wmsromaneio_id)
                window.open(routeData.href, '_blank')
              }
            }).then(() => {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: res.data.message,
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                const routeData = this.$router.resolve(`/wmsromaneio/editar/` + this.idRomaneioAssoc)
                window.open(routeData.href, '_blank')
              })
            })
          }else{
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: res.data.message,
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              const routeData = this.$router.resolve(`/wmsromaneio/editar/` + this.idRomaneioAssoc)
              window.open(routeData.href, '_blank')
            })
          }
        } else {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.error,
            showConfirmButton: false,
            timer: 2500
          })
        }

        this.atualizaDataList()
      })
    },

    confirmarAssocRomaNovo(){
      console.log('confirmarAssocRomaNovo')
      const transpRoma = this.dataGrid.getSelectedRowsData()[0]['transpcnpj']
      console.log('transp: ' , transpRoma)
      const idsAtualizar = this.idsSelecionadosNaoCancelados()
      console.log('idsAtualizar')
      console.log(idsAtualizar)
      this.updating = true
      api.post(`${getBaseUrl()}api/wmsromamovnv`, {
        idsData: idsAtualizar,
        transpmov: transpRoma
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.showAssocRoma = false
        this.updating = false
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          const routeData = this.$router.resolve(`/wmsromaneio/editar/` + res.data[0].id)
          window.open(routeData.href, '_blank')
        })
      })
      this.atualizaDataList()
    },

    confirmarAssocRomaNovo2(){
      console.log('confirmarAssocRomaNovo2')
      const idsAtualizar = this.idsSelecionadosNaoCancelados()
      this.updating = true

      api.post(`${getBaseUrl()}api/wmsromamovnv`, {
        idsData: idsAtualizar,
        transp: this.transpCriarRomaneio,
        origem: 'mov'
      }).then((res) => {
        console.log('then axios confirmarAssocRomaNovo2')
        console.log(res.data)
        this.showAssocRoma = false
        this.updating = false
        this.transpCriarRomaneio = null

        if(res.data.success){
          if(res.data.listMovsNaoAssociadas && res.data.listMovsNaoAssociadas.length > 0){
            Swal.fire({
              position: "center",
              icon: "warning",
              title: "Algumas notas não puderam ser associadas!",
              showConfirmButton: true,
              showCancelButton: true,
              confirmButtonText: 'Baixar erros',
              cancelButtonText: 'Ir para romaneio',
            }).then(escolha => {
              if(escolha.isConfirmed){
                // Monta o conteúdo do arquivo
                let conteudo = res.data.listMovsNaoAssociadas
                    .map(item => `Nota Fiscal: ${item.numnf ?? '-'} | ID: ${item.mov_id} | Erro: ${item.error} | Id Romaneio: ${item.wmsroma_id}`)
                    .join('\n'); // Garante a quebra de linha entre mensagens

                // Cria um Blob com os dados em formato de texto
                const blob = new Blob([conteudo], { type: 'text/plain' });

                // Cria um link temporário para download
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = 'erros_notas.txt';

                // Adiciona ao DOM e clica no link para iniciar o download
                document.body.appendChild(link);
                link.click();

                // Remove o link do DOM após o download
                document.body.removeChild(link);

                const routeData = this.$router.resolve(`/wmsromaneio/editar/` + res.data.wmsromaneio_id)
                window.open(routeData.href, '_blank')
              }else{
                const routeData = this.$router.resolve(`/wmsromaneio/editar/` + res.data.wmsromaneio_id)
                window.open(routeData.href, '_blank')
              }
            }).then(() => {
              this.atualizaDataList()
            })
          }else{
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              const routeData = this.$router.resolve(`/wmsromaneio/editar/` + res.data.wmsromaneio_id)
              window.open(routeData.href, '_blank')
            }).then(() => {
              this.atualizaDataList()
            })
          }
        }else{
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.error,
            showConfirmButton: false,
            timer: 2500
          }).then(() => {
            this.atualizaDataList()
          })
        }
      })
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')

      localStorage.setItem('filtros', JSON.stringify({
        'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
        'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
      }))


      this.showModalPeriodo = false
      this.atualizaDataList()
    },

    applyStatusFilter() {
      console.log('Selected Status:', this.selectedStatus);
      this.$refs.dataGridRefKey.instance.columnOption('mov_status', 'filterValue', this.selectedStatus);
    },

    carregouGrid(e){
      console.log('carregouGrid')
      // console.log(this.dataGrid.deselectAll())
      // e.component.deselectAll

      const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
      const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')

      this.title = `(${e.component.totalCount()}) Notas Fiscais: ${dtIniFormated} - ${dtFimFormated}`



    },

    atualizaDataList(){
      console.log('atualizaDataList_mov')
      console.log(this.exibEmit)

      const filtros = JSON.parse(localStorage.getItem("filtros"))
      console.log('filtros')
      console.log(filtros)
      if (!filtros) {
        console.log('cookie dataMov não existe, criando')
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }

      if (!this.dtIniFiltro && !this.dtFimFiltro){
        console.log('sem filtro')
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }

      const exibEmit = this.exibEmit
      const exibDest = this.exibDest
      const exibAmbos = this.exibAmbos
      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      this.dataList = new CustomStore({
        key: "mov_id",
        load: function(loadOptions){

          console.log('exibEmit')
          console.log(exibEmit)

          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
            'ee': exibEmit,
            'ed': exibDest,
            'ea': exibAmbos,
            'di': di,
            'df': df
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/movsnova`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data_0')
            console.log(response)

            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })


    },


    gerarSeparacao(){
      console.log('gerarSeparacao')

      //console.log('linhas selecionadas:')
      //console.log(JSON.stringify(this.dataGrid.getSelectedRowsData()))

      const linhas = this.dataGrid.getSelectedRowsData()
      const validacaoEmpresas = this.validaEmpresasSelecionadas(linhas)
      if (!validacaoEmpresas) {
        return
      }

      if(linhas.length > 50) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Máximo de 50 notas por vez!",
          showConfirmButton: false,
          timer: 2500
        })
        return
      }

      const idsAtualizar = this.idsSelecionadosNaoCancelados()
      console.log('idsAtualizar')
      console.log(JSON.stringify(idsAtualizar))

      if (idsAtualizar.length === 0) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Nenhum movimento foi selecionado, favor selecionar.",
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        Swal.fire({
          position: "center",
          icon: "question",
          input: 'select',
          inputValue: 't',
          inputOptions: {
            t: 'Todos os movimentos',
            //s: 'Contendo produtos de Saldo Positivo'
          },
          title: "Gerar Ordens de Serviço (Movimentos " + idsAtualizar + ")",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {
          console.log(result)
          console.log(result.value)
          if (result.value) {
            this.updating = true
            console.log('vai Atualizar')
            api.get(`${getBaseUrl()}api/movsgeraos`,{
              params: {
                'ids': idsAtualizar,
                'tipo': result.value,
                'remetcnpj': this.remetCnpj
              }
            }).then(response => {
              console.log('then axios movsgeraos')
              // console.log(JSON.stringify(response.data))
              console.log(response.data)

              this.dtListErrors = response.data.listErrors
              this.dtListErrorsProdutos = response.data.produtoErrors.errors

              this.dadosAssocLote = response.data.defLotes


              if(!response.data.success){
                Swal.fire({
                  position: "center",
                  icon: "error",
                  title: response.data.error,
                  text: "Deseja visualizar erros com mais detalhes?",
                  showConfirmButton: true,
                  showCancelButton: true,
                  confirmButtonText: "Sim",
                  cancelButtonText: "Não",
                }).then((confirmed) => {
                  if(confirmed.isConfirmed){
                    //console.log(`Quantidade dtListErrors: ${this.dtListErrors.length}`)
                    //console.log(JSON.stringify(this.dtListErrors))

                    //console.log(`Quantidade dtListErrorsProdutos: ${this.dtListErrorsProdutos.length}`)
                    //console.log(JSON.stringify(this.dtListErrorsProdutos))

                    if(this.dtListErrors.length > 0) {
                      this.showModalErros = true
                    }

                    if (this.dtListErrorsProdutos.length > 0) {
                      this.listaIds = response.data.origens_id
                      this.showModalErrosProdutos = true
                    }
                  }
                })
                this.updating = false
              }else{
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: "Movimento(s) processado(s) com sucesso!",
                  text: response.data.message,
                  showConfirmButton: false,
                  timer: 1500
                }).then(() => {
                  if(this.dtListErrors.length > 0 || this.dtListErrorsProdutos > 0){
                    Swal.fire({
                      position: "center",
                      icon: "warning",
                      title: "Alguns movimentos não foram Gerados OS!",
                      text: "Deseja visualizar lista de erros?",
                      showConfirmButton: true,
                      showCancelButton: true,
                      confirmButtonText: "Sim",
                      cancelButtonText: "Não",
                    }).then((confirmed) => {
                      if(confirmed.isConfirmed){
                        if(this.dtListErrors.length > 0) {
                          console.log('modal erros')
                          this.showModalErros = true
                        }
                      }else{
                        this.$router.push('/wmsossaida/list')
                      }
                    })
                  }else{
                    if(this.dadosAssocLote.flagEmpreparamWmsosLote && (this.dadosAssocLote.itensLotesAdefinir && this.dadosAssocLote.itensLotesAdefinir.length > 0)) {
                      this.dtListAssociaLote = this.dadosAssocLote.itensLotesAdefinir
                      this.showModalAssociaLotes = true
                    } else {
                      this.$router.push('/wmsossaida/list')
                    }
                  }
                })
                this.updating = false
              }
            })
          }
        })
      }
    },

    atualizaPagina(){
      window.location.reload()
    },


    abrirMovStatus(){
      console.log('abrirMovStatus')
      this.$router.push(`/movimentos/liststatus`)

    },

    mudouExib(){
      console.log('mudouExib')
      if (!this.updating)
        this.atualizaDataList()
    },

    novoMov(){
      console.log('novoMov')
      this.$router.push(`/movimento/importar/0`)
    },

    onRowDblClick(row) {
      console.log('onRowDblClick')
      let idData = row.key
      console.log(idData)
      // this.$router.push(`/movimento/editar/${idData}`)
      const routeData = this.$router.resolve(`/movimento/editar/${idData}`)
      window.open(routeData.href, '_blank')
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "mov_status") {
          const valStatus = e.data.mov_status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            //Adicionado Evandro Globopharma
            case 'EFN':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'TRA':
              corStatus = 'rgba(146,111,0,0.5)'
              break
            //fim adição Evandro Globopharma

            case 'EL':
              corStatus = 'rgba(78,59,0,0.5)'
              break
            case 'CF':
              corStatus = 'rgba(0,58,78,0.5)'
              break
            case 'ENP':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'ECR':
              corStatus = 'rgba(146,73,0,0.5)'
              break
            case 'EAT':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'NED':
              corStatus = 'rgba(146,73,0,0.5)'
              break
            case 'NEF':
              corStatus = 'rgba(146,20,0,0.5)'
              break
            case 'SCT':
              corStatus = 'rgba(146,111,0,0.5)'
              break
            case 'CCT':
              corStatus = 'rgba(0,58,78,0.5)'
              break
            //case 'TRA':
            //  corStatus = 'rgba(146,20,0,0.5)'
            //  break
            case 'ENR':
              corStatus = 'rgba(160,80,0,0.5)'
              break
            case 'CAN':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;

        } else if (e.column.dataField === "diasentrega") {
          const valDias = e.data.diasentrega
          let corDias = null
          if (valDias === null || valDias === undefined || valDias === '') {
            corDias = 'rgba(0,0,0,0.38)'
          } else if (valDias < 0) {
            corDias = 'rgba(146,20,0,0.5)'
          } else {
            corDias = 'rgba(33,78,0,0.5)'
          }

          e.cellElement.style.cssText = `color: white; background-color: ${corDias}`;
        } else if (e.column.dataField === "mov_stsordcol") {
          const valStatus = e.data.mov_stsordcol
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'PRG':
              corStatus = 'rgba(78,59,0,0.5)'
              break
            case 'ENV':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'CAN':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;

        }
      }
    },


    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    // ==========================================================================
    // FLUXO NOVO DE EXPORTAÇÃO
    // A planilha é gerada no servidor, em blocos. Estes métodos não tocam em
    // `updating` (que desmontaria a grid), nem no onExporting(), nem no estado
    // da grid. Para desativar, comente os DxItem marcados na toolbar e
    // descomente o <DxExport> no DxDataGrid.
    // ==========================================================================

    exportarPeriodoExcel() {
      console.log('exportarPeriodoExcel')

      if (this.exportando) return

      const filtro = this.dataGrid.getCombinedFilter(true) || null
      const ordenacao = this.dataGrid.getDataSource().sort() || null

      const temFiltro = !!filtro
      const total = this.dataGrid.totalCount()
      const quantos = temFiltro
          ? 'as notas que atendem aos filtros aplicados'
          : `${total} notas fiscais`

      Swal.fire({
        icon: 'question',
        title: 'Exportar para Excel',
        html: `Serão exportadas <b>${quantos}</b> do período de `
            + `<b>${moment(this.dtIniFiltro).format('DD/MM/YYYY')}</b> a `
            + `<b>${moment(this.dtFimFiltro).format('DD/MM/YYYY')}</b>.`
            + `<br><br>Períodos longos podem levar alguns minutos.`,
        showCancelButton: true,
        confirmButtonText: 'Exportar',
        cancelButtonText: 'Cancelar'
      }).then((escolha) => {
        if (!escolha.isConfirmed) return
        this.baixarPlanilhaNotas(filtro, ordenacao)
      })
    },

    baixarPlanilhaNotas(filtro, ordenacao) {
      this.exportando = true

      Swal.fire({
        title: 'Gerando a planilha...',
        html: 'A tela continua disponível. O download começa automaticamente quando o arquivo ficar pronto.',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => Swal.showLoading()
      })

      const di = this.dtIniFiltro
      const df = this.dtFimFiltro

      api.post(`${getBaseUrl()}api/movsnovaexport`, {
        di: di,
        df: df,
        filtro: filtro ? JSON.stringify(filtro) : null,
        ordenacao: ordenacao ? JSON.stringify(ordenacao) : null
      }, {
        responseType: 'blob'
      }).then((res) => {
        const nome = `Notas_Fiscais_${di}_a_${df}.xlsx`
        const blob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = nome
        link.click()
        window.URL.revokeObjectURL(url)

        Swal.fire({
          icon: 'success',
          title: 'Planilha gerada',
          html: `O download de <b>${nome}</b> foi iniciado.`,
          timer: 4000,
          timerProgressBar: true
        })
      }).catch((error) => {
        console.error('Erro ao exportar notas:', error)
        // com responseType blob o corpo do erro vem como Blob, não como JSON
        const status = error.response ? error.response.status : null
        Swal.fire({
          icon: 'error',
          title: 'Não foi possível gerar a planilha',
          html: status
              ? `O servidor respondeu com erro <b>${status}</b>. Tente um período menor ou avise o suporte.`
              : 'A conexão foi interrompida antes do arquivo ficar pronto. Tente um período menor.'
        })
      }).finally(() => {
        this.exportando = false
      })
    },

    exportarSelecionadosExcel() {
      console.log('exportarSelecionadosExcel')

      if (this.exportando) return

      const selecionados = this.dataGrid.getSelectedRowKeys()
      if (!selecionados || selecionados.length === 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Nenhuma nota selecionada',
          text: 'Marque ao menos uma linha para exportar, ou use "Exportar período" para exportar todas.'
        })
        return
      }

      this.exportando = true

      const workbook = new Workbook()
      const worksheet = workbook.addWorksheet('plan1')

      exportDataGrid({
        component: this.dataGrid,
        worksheet,
        selectedRowsOnly: true
      }).then(() => {
        return workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Notas_Fiscais_selecionadas.xlsx')
          Swal.fire({
            icon: 'success',
            title: 'Planilha gerada',
            html: `<b>${selecionados.length}</b> nota(s) exportada(s).`,
            timer: 3000,
            timerProgressBar: true
          })
        })
      }).catch((error) => {
        console.error('Erro ao exportar selecionadas:', error)
        Swal.fire({
          icon: 'error',
          title: 'Não foi possível gerar a planilha',
          text: 'Ocorreu uma falha ao montar o arquivo das notas selecionadas.'
        })
      }).finally(() => {
        this.exportando = false
      })
    },

    // ===================== fim do FLUXO NOVO DE EXPORTAÇÃO =====================

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    nomeStatus(e) {

      switch (e.value) {
        case 'EL':
          return 'Elaboração(EL)'
        case 'PR':                   // desativado
          return 'Ordem Saída (PR)'  // desativado
        case 'OS':
          return 'Ordem Saída (OS)'
        case 'CF':
          return 'Pedido Conferido (CF)'
        case 'NEM':
          return 'Nota Fiscal Emitida (NEM)'
        case 'NLO':
          return 'Não Encontrado (NLO)'
        case 'ENP':
          return 'Entregue no Prazo (ENP)'
        case 'ECR':
          return 'Entregue com Ressalva (ECR)'
        case 'EAT':
          return 'Entregue com Atraso (EAT)'
        case 'CCT':
          return 'Com CTe (CCT)'
        case 'TRA':
          return 'Em Trânsito(TRA)'
          //return 'Transferido (TRA)'
        case 'CAN':
          return 'Cancelado (CAN)'


        case 'SCT':
          return 'Sem CTe'
        case 'NEP':
          return 'Em Trânsito (Dentro do Prazo)'
          //      return 'Dentro do Prazo (Não Entregue)'
        case 'NEF':
          return 'Em Trânsito (Fora do Prazo)'

        case 'EFN':
          return 'Entrega finalizada (EFN)'
        case 'OCC':
          return 'Ocorrência (OCC)'
        case 'INS':
          return 'Insucesso de entrega (INS)'
        case 'ENR':
          return 'Em rota de entrega (ENR)'
      }

      return e.value
    },

    nomeStatusEnvOrdem(e) {

      switch (e.value) {
        case 'PRG':
          return 'Programado (PRG)'
        case 'ENV':
          return 'Enviado (ENV)'
        case 'CAN':
          return 'Cancelado (CAN)'
      }

      return e.value
    },

  },

};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true"/>

    <div>

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="increaselinespacing"
              hint="Gerar Separação"
              :on-click="gerarSeparacao"/>
        </DxItem>

        <!--<DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="decreaseindent"
              hint="Associar a Romaneio"
              :on-click="associarRomaneio"/>
        </DxItem>-->


        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="belloutline"
              hint="Envio de Ordem de Coleta"
              :on-click="envioOrdemColeta"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="money"
              hint="Criar pedido baseado na NF-e"
              :on-click="criarPedido"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="save"
              hint="Associar Nota a uma Cotação"
              :on-click="associarMovCotacao"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="search"
              hint="Verificar saldo produto"
              text="Validar saldo de produto"
              :on-click="validaSaldoProduto"/>
        </DxItem>

          <DxItem
              location="before"
              widget="dxButton">
            <DxButton
                icon="export"
                text="Gerar DANFE"
                :on-click="gerarDANFE"/>
          </DxItem>

          <DxItem
              location="before"
              widget="dxButton">
            <DxButton
                icon="to"
                text="Enviar XML Transp."
                hint="Enviar o arquivo de XML da nota fiscal para o transportador citado na nota fiscal"
                :on-click="dispararXMLTransportadora"/>
          </DxItem>



        <!-- ==========================================================================
             FLUXO NOVO DE EXPORTAÇÃO — comentar os dois DxItem abaixo e descomentar
             o <DxExport> no DxDataGrid para voltar ao fluxo antigo.
             ========================================================================== -->
        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="xlsxfile"
              text="Exportar período"
              hint="Exportar para Excel todas as notas do período (respeita os filtros das colunas)"
              :disabled="exportando"
              :on-click="exportarPeriodoExcel"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="xlsxfile"
              hint="Exportar para Excel apenas as notas selecionadas"
              :disabled="exportando"
              :on-click="exportarSelecionadosExcel"/>
        </DxItem>
        <!-- ===================== fim do FLUXO NOVO DE EXPORTAÇÃO ==================== -->

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="plus"
              id="btnImportarXml"
              hint="Importar arquivo XML"
              text="Importar arquivo XML"
              :on-click="novoMov"/>

          <b-dropdown
              v-model="selectedStatus"
              class="float-end"
              right
              style="margin-left: 5px"
              variant="primary"
              menu-class="dropdown-menu-end"
              @change="applyStatusFilter">
            <template v-slot:button-content>
              <i class="mdi mdi-filter-plus me-1"></i> Filtrar Status
            </template>
            <b-form-select v-model="selectedStatus">
              <option :value="null" disabled>-- Selecione uma opção --</option>
              <option v-for="option in options" :value="option.value" :key="option.value">
                {{ option.text}}
              </option>
            </b-form-select>
          </b-dropdown>
        </DxItem>



        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              id="btnAjuda"
              icon="help"
              style="background-color: #50a5f1; color: white;"
              text="Ajuda"
              type="normal"
              :on-click="ajuda"/>
        </DxItem>

      </DxToolbar>
    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>

    <div class="mt-2">
      <p><strong>Itens Selecionados: {{ selectedItems }}</strong></p>
    </div>

    <div class="mt-2" v-if="!updating">

      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting"
          @selection-changed="atualizarItensSelecionados"
      >

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />


        <DxSelection mode="multiple"
        selectAllMode="page"/> <!--:allow-select-all="false"-->

        <!-- ==========================================================================
             FLUXO ANTIGO DE EXPORTAÇÃO (menu "Export to Excel" do DevExtreme)
             Desativado em favor dos botões "Exportar período" / "Exportar selecionados"
             da toolbar, que geram a planilha no servidor.

             PARA VOLTAR AO FLUXO ANTIGO: descomentar o <DxExport> abaixo e comentar
             os dois DxItem marcados como "FLUXO NOVO DE EXPORTAÇÃO" na toolbar.
             O onExporting() segue intacto e volta a ser acionado automaticamente.
             ========================================================================== -->
        <!--
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        -->
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strMovList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />

        <DxColumn
            :width="330"
            caption="Movimentos"
            alignment="center"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="mov_id"
              sort-order="desc"
              caption="ID"
              data-type="number"
              alignment="right"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>


          <DxColumn
              data-field="mov_status"
              caption="Status"
              alignment="center"
              data-type="text"
              :customize-text="nomeStatus"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true">

          </DxColumn>

          <DxColumn
              data-field="mov_stsordcol"
              caption="Ordem Coleta"
              alignment="center"
              data-type="text"
              :customize-text="nomeStatusEnvOrdem"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true">
          </DxColumn>

          <DxColumn
              data-field="mov_wmsosid"
              caption="Ordem Serviço"
              alignment="right"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true">
          </DxColumn>

          <DxColumn
              data-field="mov_wmsromaneio_id"
              caption="Romaneio"
              alignment="right"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true">
          </DxColumn>

          <DxColumn
              data-field="mov_dtemissao"
              caption="Emissão"
              alignment="right"
              data-type="datetime"
              format="dd/MM/yyyy"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="mov_dtcompr"
              caption="Comprovante"
              alignment="right"
              data-type="datetime"
              format="dd/MM/yyyy"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="mov_codigo"
              caption="NF"
              alignment="right"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="mov_valorliq"
              caption="Valor"
              alignment="right"
              :format="formatDecimal"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="mov_pesobrt"
              caption="Peso"
              alignment="right"
              :format="formatDecimal"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="mov_valorfrete"
              caption="Frete Loja"
              alignment="right"
              :format="formatDecimal"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true" />

          <DxColumn
              data-field="mov_dtentrega"
              caption="Dt Entrega"
              alignment="right"
              data-type="datetime"
              format="dd/MM/yyyy"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="mov_created_at"
              caption="Dt Recebimento NF"
              alignment="right"
              data-type="datetime"
              format="dd/MM/yyyy HH:mm:ss"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              data-field="mov_natop"
              caption="Natureza"
              alignment="left"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true" />

        </DxColumn>

        <DxColumn
            :width="330"
            caption="Rastreamento"
            alignment="center"
            :allowHeaderFiltering="false">

            <DxColumn
              data-field="mov_stsentr"
              caption="Entrega"
              alignment="center"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true" />

            <DxColumn
              :width="80"
              data-field="mov_tracking"
              caption="Rastreio"
              alignment="center"
              data-type="boolean"
              :allowHeaderFiltering="true"
              
            />

            <DxColumn
              data-field="mov_obsentr"
              caption="Obs Entrega"
              alignment="left"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true" />
          
            <DxColumn
              data-field="obsrastreio"
              caption="Obs Rastreio"
              alignment="left"
              data-type="text"
              :allowFiltering="false"
              :allowHeaderFiltering="false" />
          
            <DxColumn
              data-field="mov_dtultocor"
              caption="Ocorrência"
              alignment="right"
              data-type="datetime"
              format="dd/MM/yyyy"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="true"/>

            <DxColumn
              data-field="mov_tracked_at"
              caption="Atualizada em"
              alignment="right"
              data-type="datetime"
              format="dd/MM/yyyy HH:mm:ss"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false"/>

            <DxColumn
              data-field="w_trk_data"
              caption="Processada em"
              alignment="right"
              data-type="datetime"
              format="dd/MM/yyyy HH:mm:ss"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false"/>

            <DxColumn
              data-field="status_processamento"
              caption="Status Processamento"
              alignment="center"
              data-type="string"
              :filter-operations="['contains', 'notcontains', '=', '<>']"
              :allowHeaderFiltering="true"/>

          </DxColumn>

        <DxColumn
            :width="330"
            caption="CTE"
            alignment="center"
            :allowHeaderFiltering="false">

          <DxColumn
              :width="80"
              data-field="mov_numcte"
              caption="Número"
              alignment="right"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true"/>

          <DxColumn
              :width="100"
              data-field="mov_dtemicte"
              caption="Dt Emissão"
              alignment="right"
              data-type="datetime"
              format="dd/MM/yyyy"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false"/>

          <DxColumn
              :width="100"
              data-field="mov_dtpreventr"
              caption="Previsão"
              alignment="right"
              data-type="datetime"
              format="dd/MM/yyyy"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false"/>

          <DxColumn
              :width="100"
              data-field="mov_dtpreventrep"
              caption="Previsão Rep"
              alignment="right"
              data-type="datetime"
              format="dd/MM/yyyy"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false"/>

          <DxColumn
              :width="110"
              data-field="prazo_cotacao"
              name="cotacao_previsao"
              caption="Prazo Tab."
              alignment="right"
              data-type="number"
              :allowFiltering="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="mov_pesocte"
              caption="Peso"
              :format="formatDecimal"
              alignment="right"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false" />

          <DxColumn
              data-field="mov_valorcte"
              caption="Valor Frete"
              alignment="right"
              :format="formatDecimal"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false" />

          <DxColumn
              data-field="mov_valfreteprop"
              caption="Valor Frete Prop."
              alignment="right"
              :format="formatDecimal"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false" />

          <DxColumn
              data-field="mov_prazo"
              caption="Prazo"
              alignment="right"
              data-type="text"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="diasentrega"        
              caption="Dias Entrega"
              alignment="right"
              data-type="number"
              :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="statusPrazo"
              caption="Status Prazo"
              alignment="left"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allowHeaderFiltering="true" />


        </DxColumn>



        <DxColumn
            :width="330"
            caption="Destinatário"
            alignment="center"
            :allow-sorting="false"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="destnome"
              caption="Nome"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="destcnpj"
              caption="CNPJ"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="destcidade"
              caption="Cidade"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="destregiao"
              caption="Região"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="destestado"
              caption="Estado"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

        </DxColumn>


        <DxColumn
            :width="330"
            caption="Remetente"
            alignment="center"
            :allow-sorting="false"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="remetnome"
              caption="Nome"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="remetcnpj"
              caption="CNPJ"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="remetcidade"
              caption="Cidade"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="remetestado"
              caption="Estado"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

        </DxColumn>

        <DxColumn
            :width="330"
            caption="Transportador"
            alignment="center"
            :allow-sorting="false"
            :allowHeaderFiltering="false">

          <DxColumn
              data-field="nometransp"
              caption="Nome"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="transpcnpj"
              caption="CNPJ"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="transpcidade"
              caption="Cidade"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

          <DxColumn
              data-field="transpestado"
              caption="Estado"
              data-type="text"
              :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
              :allow-sorting="false"
              :allowHeaderFiltering="false"/>

        </DxColumn>



        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>


      </DxDataGrid>


    </div>


    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>


    <b-modal title="Associar a Romaneio"
             size="lg"
             v-model="showAssocRoma"
             centered hide-footer>
      <div class="col-md-12">

        <div class="mb-3">
          <span>Selecionar Romaneio  {{ idRomaneioAssoc }}</span>

          <multiselect id="inputRomaneio"
                       @search-change="pesqRomaneio"
                       v-model="idRomaneioAssoc"
                       placeholder="Pesquisar romaneio"
                       :options="dtListPesqRoma"
                       :searchable="true"
                       label="nome"
                       track-by="nome"
                       value-prop="id">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.id }}
                  </span>
                  <span class="mx-4" >
                    {{ slotProps.option.cnpj }}
                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                <div class="align-items-end text-end align-content-end">{{ slotProps.option.motorista }}</div>
              </div>
            </template>
          </multiselect>

        </div>

        <div class="text-end mt-5">


          <b-button variant="light" @click="showAssocRoma = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>


          <b-button variant="outline-success" class="ms-1" @click="indicaTranspAssocRomaneio">
            <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
            Criar e Associar a Novo Romaneio
          </b-button>

          <b-button :disabled="idRomaneioAssoc === 0"
                    type="submit" variant="success" class="ms-1" @click="confirmarAssocRoma2">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>

        </div>
      </div>
    </b-modal>


    <b-modal title="Enviar Ordem de Coleta"
             size="md"
             v-model="showEnviarOrdemColeta"
             centered hide-footer>

      <div class="row">
        <div class="col-md-12">

          <div class="col-sm-12 mt-3 mb-3">
            <div class="mb-3">

              <h4>Movimentos:</h4>
              <span class="text-dark mb-4">{{ idsAtualizar }}</span>

<!--              <h5 class="font-size-14 mt-2">Enviar / Programar</h5>-->
<!--              <b-form-checkbox-->
<!--                  switch size="lg"-->
<!--                  value="A"-->
<!--                  unchecked-value="I"-->
<!--                  v-model="enviarOuProgrOrdemCol">-->
<!--                {{ enviarOuProgrOrdemCol === 'A' ? 'Enviar Imediatamente' : 'Programar Envio' }}-->
<!--              </b-form-checkbox>-->

            </div>
          </div>


          <div class="text-end mt-5">

            <b-button variant="light" @click="showEnviarOrdemColeta = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>


            <!--          <b-button variant="outline-success" @click="confirmarAssocRomaNovo">-->
            <!--            <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>-->
            <!--            Criar e Associar a Novo Romaneio-->
            <!--          </b-button>-->

            <b-button type="submit" variant="success" class="ms-1" @click="confirmarEnvioOrdemColeta">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>

          </div>
        </div>


      </div>


    </b-modal>

    <b-modal
        v-model="showModalCriarPedido"
        size="sm"
        title="Tipo de geração de pedido"
        title-class="font-18"
        hide-footer
    >
      <multiselect id="flagGeraPed"
                   @search-change="pesqRomaneio"
                   v-model="flagGeraPed"
                   placeholder="Selecionar tipo de geração de pedidos"
                   :options="flagGeraPedOptions"
                   :searchable="true"
                   label="flagGeraPed">
      </multiselect>

      <div class="mt-5 d-flex justify-content-center">
        <b-button variant="success">Gerar pedido</b-button>
      </div>
    </b-modal>


    <b-modal title="Detalhes Transportadora" v-model="showModalTransp" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Nova Transportadora</span>

          <multiselect id="repres"
                       @search-change="pesqTransp"
                       @select="confirmarTransp"
                       v-model="transpCriarRomaneio"
                       placeholder="Pesquisar transportadora"
                       :options="dtListPesqTransp"
                       :searchable="true"
                       label="nome"
                       track-by="nome"
                       value-prop="cnpj">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.cnpj }}
                  </span>
                  <span class="mx-4" >

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingTransp">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalTransp = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarTransp">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>

    </b-modal>


    <b-modal
      v-model="showModalErros"
      id="showModalErros"
      size="lg"
      title="Erros gerados na ação"
      title-class="font-18"
      hide-footer
    >
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Erro</th>
                      <th>Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="data in dtListErrors" :key="data.id">
                      <td>{{data.erro}}</td>
                      <td>{{data.valor}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>       
      </div>
    </b-modal>

    <b-modal
        v-model="showModalErrosProdutos"
        id="showModalErrosProdutos"
        size="xl"
        title="Validação de saldo de produtos"
        title-class="font-18"
        hide-footer
    >
      <div class="row">

        <div class="mb-2 d-flex justify-content-end">
          <b-button
              type="submit"
              variant="danger"
              @click="gerarRelatorioValidacaoSaldo"
          >
            <i class="bx bxs-file-pdf font-size-16 align-middle"></i>
            Exportar
          </b-button>
        </div>

        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                  <tr>
                    <th>Origem</th>
                    <th>Nota|Pedido</th>
                    <th>Produto</th>
                    <th>Código</th>
                    <th>ID</th>
                    <th>Lote</th>
                    <th>Qtd. Disponível</th>
                    <th>Qtd. Necessária</th>
                    <!--<th>Obs</th>-->
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="data in dtListErrorsProdutos" :key="data.id">
                    <td class="text-start">{{data.origem}}</td>
                    <td class="text-start">{{data.codigo}}</td>
                    <td class="text-start">{{data.produto_desc}}</td>
                    <td class="text-start">{{data.produto_cod}}</td>
                    <td class="text-center">{{data.produto_id}}</td>
                    <td class="text-start">{{data.lote ?? "-"}}</td>
                    <td class="text-center">{{formatDecimal(data.qtddisp)}}</td>
                    <td class="text-center">{{formatDecimal(data.qtdnecessaria)}}</td>
                    <!--<td class="text-start">{{data.message ?? "-"}}</td>-->
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div>
            <h6 class="text-danger text-end">Deseja gerar um ajuste de entrada?</h6>
          </div>

          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalErrosProdutos = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button
                type="submit"
                variant="success"
                class="ms-1"
                :disabled="disableButton"
                @click="criaMovAjtFromMov"
            >
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
        v-model="showModalAssociaLotes"
        id="showModalAssociaLotes"
        size="xl"
        title="Associação de lotes"
        title-class="font-18"
        hide-footer
    >
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                  <tr>
                    <th>Nota Fiscal</th>
                    <th>Produto</th>
                    <th>Código</th>
                    <th>ID</th>
                    <th>Qtd.</th>
                    <th>Lote</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="data in dtListAssociaLote" :key="data.id">
                    <td class="text-start">{{data.notaFiscal}}</td>
                    <td class="text-start">{{data.descprod}}</td>
                    <td class="text-start">{{data.produto}}</td>
                    <td class="text-center">{{data.produto_id}}</td>
                    <td class="text-center">{{formatDecimal(data.qtd)}}</td>
                    <td class="text-center" style="width: 200px">
                      <multiselect
                          id="lotes"
                          v-model="data.lote"
                          :options="data.optionsLotes"
                          placeholder="Selecionar lotes"
                          label="cod"
                          track-by="cod"
                          value-prop="cod"
                      >
                        <template #option="slotProps">
                          <div class="row">
                            <div class="mt-2 font-size-16">
                              <span class="text-info">
                                {{ slotProps.option.cod }}
                              </span>
                              <span class="ms-2">
                                {{ `(Qtd: ${slotProps.option.saldo})` }}
                              </span>
                            </div>
                          </div>
                        </template>
                      </multiselect>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div v-if="updatingReserva">
            <h3 class="text-info text-center">Aguarde um momento, estamos reservando os saldos dos produtos...</h3>
          </div>

          <div class="row" v-if="updatingReserva">
            <div class="col-12 text-center">
              <b-spinner type="grow"
                         class="m-6 mx-2"
                         variant="secondary"
                         role="status">
              </b-spinner>
              <b-spinner type="grow"
                         class="m-6 mx-2"
                         variant="secondary"
                         role="status">
              </b-spinner>
              <b-spinner type="grow"
                         class="m-6 mx-2"
                         variant="secondary"
                         role="status">
              </b-spinner>
            </div>
          </div>

          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalAssociaLotes = false" :disabled="updatingReserva">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>

            <b-button
                type="submit"
                variant="success"
                class="ms-1"
                @click="gerarReservaSaldos"
                :disabled="updatingReserva"
            >
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal title="Associar Movimento a Cotações"
             size="lg"
             v-model="showMovalAssocMov"
             centered hide-footer>

      <div class="row">
        <div class="col-lg-12">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-2">
                  <p class="text-muted mb-2"> Cotações selecionada:</p>
                  <h5 class="mb-0" v-if="cotaAssociado !== null"> {{ `${cotaAssociado.id} | ${cotaAssociado.codigo ?? '-'} | ${cotaAssociado.tipo ?? '-'} | ${cotaAssociado.segto ?? '-'} | ${cotaAssociado.nome ?? '-'} | ${formatDateTime(cotaAssociado.created_at)}` }} </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <h6 class="muted text-danger">Apenas 1 nota pode será vinculada</h6>
            <span>Selecionar Cotações ID:</span>
            <multiselect id="idCotAssoc"
                         @search-change="pesqCotacao"
                         v-model="idCotAssoc"
                         @select="formatCotaAssociado"
                         placeholder="Pesquisar cotações"
                         :options="dtListPesqCota"
                         :searchable="true"
                         label="codigo"
                         track-by="codigo"
                         value-prop="id">
              <template #option="slotProps">
                <div class="row">
                  <div>
                    <span class="text-info">
                      {{ slotProps.option.id }} |
                    </span>
                    <span class="text-info">
                      {{ slotProps.option.codigo ?? "-" }} |
                    </span>
                    <span class="me-2">
                      {{ slotProps.option.tipo ?? "-" }} |
                    </span>
                    <span class="me-2">
                      {{ slotProps.option.segto ?? "-" }} |
                    </span>
                    <span class="me-2">
                      {{ slotProps.option.nome ?? "-" }} |
                    </span>
                    <span class="me-2">
                      {{ formatDateTime(slotProps.option.created_at) }} |
                    </span>
                    <span class="me-2">
                      {{ slotProps.option.created_by ?? "-" }}
                    </span>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>



          <div class="text-end mt-5">
            <b-button variant="light" @click="showMovalAssocMov = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>

            <b-button :disabled="idCotAssoc === 0"
                      type="submit" variant="success" class="ms-1" @click="confirmarAssocMov()">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>



<style>
#btnAjuda .dx-icon {
  color: #fff !important;
}
</style>

